import React from 'react';
import { motion } from 'framer-motion';
import { Check, Target, TrendingUp } from 'lucide-react';
const forYouList = ['Trabajás con pacientes que presentan insomnio, ansiedad, estrés o burnout.', 'Querés saber qué evaluar cuando un paciente dice “duermo mal”.', 'Buscás una estructura clara para intervenir sin dar consejos genéricos.', 'Necesitás herramientas prácticas para pensamientos, hábitos y seguimiento del sueño.'];
const resultsList = ['Detectás mejor el tipo de insomnio del paciente.', 'Diseñás un plan de intervención más claro y profesional.', 'Trabajás creencias y ansiedad anticipatoria sobre el sueño.', 'Monitoreás el avance con un diario simple y aplicás técnicas con criterio.'];
export function TargetAudience() {
  return <section className="py-20 bg-white" data-id="element-189">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-190">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20" data-id="element-191">
          {/* For You If */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-50 rounded-3xl p-8 md:p-10 border border-slate-100" data-id="element-192">
            <div className="flex items-center gap-4 mb-8" data-id="element-193">
              <div className="w-12 h-12 bg-indigo-100 rounded-xl flex items-center justify-center" data-id="element-194">
                <Target className="w-6 h-6 text-navy" data-id="element-195" />
              </div>
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-navy" data-id="element-196">
                ESTE KIT ES PARA VOS SI...
              </h2>
            </div>

            <ul className="space-y-4" data-id="element-197">
              {forYouList.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-198">
                  <div className="mt-1 bg-white rounded-full p-1 shadow-sm border border-slate-100 flex-shrink-0" data-id="element-199">
                    <Check className="w-4 h-4 text-navy" data-id="element-200" />
                  </div>
                  <span className="text-slate-700 leading-relaxed" data-id="element-201">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Results */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-indigo-50/50 rounded-3xl p-8 md:p-10 border border-indigo-100" data-id="element-202">
            <div className="flex items-center gap-4 mb-8" data-id="element-203">
              <div className="w-12 h-12 bg-gold/20 rounded-xl flex items-center justify-center" data-id="element-204">
                <TrendingUp className="w-6 h-6 text-gold" data-id="element-205" />
              </div>
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-navy" data-id="element-206">
                EL RESULTADO:
              </h2>
            </div>

            <ul className="space-y-4" data-id="element-207">
              {resultsList.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-208">
                  <div className="mt-1 bg-white rounded-full p-1 shadow-sm border border-indigo-100 flex-shrink-0" data-id="element-209">
                    <Check className="w-4 h-4 text-gold" data-id="element-210" />
                  </div>
                  <span className="text-slate-700 leading-relaxed" data-id="element-211">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}